import React from "react";
import { useNavigate } from "react-router-dom";
import PatternImage from "assets/Home/Container.png";
import MobileMockupImage from "assets/Home/MobileMockup.png";
import "./Home.css";

export default function VendorApplyCTA({
  id,
  title = "Become a Trusted Properteasy Vendor Today",
  description = "Properteasy connects vetted local professionals with property maintenance jobs. Our platform centralizes job requests, scheduling, communication, and billing so you can focus on doing quality work while we handle the rest.",
  descriptionClassName = "",
  buttonText = "Apply Now",
  buttonLink = "/signup",
  onButtonClick,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
      return;
    }

    navigate(buttonLink);
  };

  return (
    <section
      id={id}
      className="homeLanding-vendorSection"
      style={{ backgroundImage: `url(${PatternImage})` }}
    >
      <div className="homeLanding-vendorInner">
        <div className="homeLanding-vendorCopy">
          <h2 className="homeLanding-vendorTitle">{title}</h2>
          <p
            className={`homeLanding-vendorDescription ${descriptionClassName}`.trim()}
          >
            {description}
          </p>
          <button
            type="button"
            className="homeLanding-button homeLanding-actionButton homeLanding-vendorButton"
            onClick={handleClick}
          >
            {buttonText}
          </button>
        </div>
        <img
          src={MobileMockupImage}
          alt="Properteasy mobile dashboard"
          className="homeLanding-vendorPhone"
        />
      </div>
    </section>
  );
}
